// extracted by mini-css-extract-plugin
module.exports = {"dialog":"addListModal_dialog__2tX9N","text":"addListModal_text__27ga8","buttonWrapper":"addListModal_buttonWrapper__hwsvd","addButton":"addListModal_addButton__3AkZM"};